import React from 'react';

import { ListViewHeading } from './list-view-heading';
import {
  Container,
  FullScreenOverlay,
  FullScreenOverlayBanner,
  TabContainer,
} from './list-view.styled';

export const ListView: React.FC<{
  tabsEl: JSX.Element | false;
  tabPanelsEl: JSX.Element;
  searchBarEl: JSX.Element;
  currentViewIsList: boolean;
}> = ({ currentViewIsList, tabsEl, tabPanelsEl, searchBarEl }) => {
  if (!currentViewIsList) {
    return null;
  }

  return (
    <FullScreenOverlay>
      <FullScreenOverlayBanner>
        <Container>
          <ListViewHeading />
          {searchBarEl}
        </Container>
      </FullScreenOverlayBanner>
      <div>
        {!!tabsEl && <TabContainer>{tabsEl}</TabContainer>}

        <Container>{tabPanelsEl}</Container>
      </div>
    </FullScreenOverlay>
  );
};

export default ListView;
